import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=2ed2db44&scoped=true"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"
import style0 from "./addPage.vue?vue&type=style&index=0&id=2ed2db44&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2db44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-manager-fe/treasurenet-tnservices-airdrop-manager-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed2db44')) {
      api.createRecord('2ed2db44', component.options)
    } else {
      api.reload('2ed2db44', component.options)
    }
    module.hot.accept("./addPage.vue?vue&type=template&id=2ed2db44&scoped=true", function () {
      api.rerender('2ed2db44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/whitelist/addPage.vue"
export default component.exports